import React, { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { ObjectType, TreeNode } from 'types/interfaces';

interface EditableTagsComponentProps {
  passedClassName?: string;
  tooltipLabel?: string;
  fieldName?: string;
  initialTagsItems: ObjectType[] | TreeNode[];
  onDelete?: (taskId: string | number) => void;
  onTagClick?: (taskId: string | number) => void;
  onEdit?: (taskId: string | number) => void;
  openDialog?: () => void;
  editable?: boolean;
}

export const EditableTagsComponent: React.FC<EditableTagsComponentProps> = ({
  passedClassName,
  tooltipLabel,
  initialTagsItems,
  fieldName = 'label',
  onDelete,
  onEdit,
  onTagClick,
  openDialog,
  editable = true
}) => {
  const [tagsItems, setTagsItems] = useState<ObjectType[] | TreeNode[]>(
    initialTagsItems
  );
  const [justDeleted, setJustDeleted] = useState(false);
  useEffect(() => {
    if (!justDeleted) {
      setTagsItems(initialTagsItems);
    } else {
      const timer = setTimeout(() => {
        setJustDeleted(false);
      }, 600);

      return () => clearTimeout(timer);
    }
  }, [initialTagsItems, justDeleted]);

  const handleDeleteTag = (taskId: string | number) => {
    onDelete && onDelete(taskId);
  };

  return (
    <div
      className={`tag-component flex flex-wrap ${
        passedClassName ? passedClassName : 'gap-3'
      }`}
    >
      {tooltipLabel && <Tooltip target=".tagItem" mouseTrack />}

      {tagsItems &&
        tagsItems.map((tagItem, index) => (
          <div
            key={(tagItem as ObjectType)?.id || (tagItem as TreeNode)?.key}
            data-pr-tooltip={tooltipLabel ?? ''}
            className={
              'tagItem flex border-round-2xl pl-2' +
              (onDelete ? '' : ' pr-2') +
              (onTagClick ? ' tagItem--clickable' : '') +
              ((tagItem as any)?.isDeleted ? ' tagItem--deleted' : '')
            }
          >
            <div className="task-status flex flex-row gap-2 align-items-center">
              {tagItem?.isDeleted && (
                <i
                  className="pi pi-exclamation-circle"
                  style={{ color: 'rgb(255, 168, 0)', fontSize: '0.85rem' }}
                  title="Удалено в справочнике"
                />
              )}
              <div
                className="flex m-0 font-medium"
                onClick={() => {
                  if (onTagClick) {
                    onTagClick(
                      (tagItem as ObjectType).id || (tagItem as TreeNode).key
                    );
                  }
                }}
              >
                {' '}
                {tagItem?.label
                  ? tagItem?.label
                  : tagItem[fieldName as keyof typeof tagItem]}
              </div>

              <div>
                {editable && (
                  <Button
                    icon="pi pi-pencil"
                    className="p-0"
                    style={{ color: '#475569', width: '2rem' }}
                    onClick={() => {
                      const id =
                        (tagItem as ObjectType).id || (tagItem as TreeNode).key;
                      if (onEdit) {
                        onEdit(id);
                      } else if (openDialog) {
                        openDialog();
                      }
                    }}
                    text
                  />
                )}
                {onDelete && (
                  <Button
                    icon="pi pi-times"
                    className="p-0"
                    style={{ color: '#475569', width: '2rem' }}
                    onClick={() =>
                      handleDeleteTag(
                        (tagItem as ObjectType).id || (tagItem as TreeNode).key
                      )
                    }
                    text
                  />
                )}
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};
